import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from '@mui/icons-material/Replay';
import { Button, Divider, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import DOMPurify from 'dompurify';
import { makeStyles } from 'tss-react/mui';
import { DateTimeFormat } from '../../../sic-lib/enums/DateTimeFormat';
import { ContactEmailThreadResponse } from '../../../sic-lib/types/ContactEmails';
import DisplayDateTime from '../../Shared/DisplayDateTime/DisplayDateTime';
import EmailFrame from './EmailFrame/EmailFrame';

interface Props {
    emailData: ContactEmailThreadResponse;
    isReplyOpen: boolean;
    onReplay: () => void;
}

export default function EmailThreadBody({ emailData, onReplay, isReplyOpen }: Props) {
    const { classes } = useStyles();

    return (
        <>
            <Grid display="flex" direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="h6" component="h2" color="text.secondary" gutterBottom>
                    {emailData.subject}
                </Typography>
                <Button
                    onClick={onReplay}
                    variant="contained"
                    startIcon={isReplyOpen ? <CloseIcon /> : <ReplayIcon />}
                >
                    {isReplyOpen ? 'Close Reply' : 'Reply'}
                </Button>
            </Grid>
            <div className={classes.container}>
                <EmailFrame>
                    {emailData.messages.map(message => (
                        <>
                            <Typography
                                variant="h6"
                                component="h2"
                                color="text.secondary"
                                gutterBottom
                            >
                                <DisplayDateTime
                                    dateText={message.messageDate}
                                    formatPreset={DateTimeFormat.dateTimeMed}
                                />
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                From: {message.from}
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                To: {message.to}
                            </Typography>
                            <Typography key={message.id} variant="body2">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(message.body),
                                    }}
                                />
                            </Typography>
                            <Divider />
                        </>
                    ))}
                </EmailFrame>
            </div>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        marginBottom: theme.spacing(4),
        overflowY: 'hidden',
        flexGrow: 1,
    },
}));
